import React from "react";

interface IconProps {
  color?: string;
  size?: number;
}

const Edit: React.FC<IconProps> = ({ color = "#09090B", size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6967 3.93398C10.9487 3.68198 11.0874 3.34731 11.0874 2.99131C11.0874 2.63531 10.9487 2.30065 10.6967 2.04865L9.63941 0.991314C9.38741 0.739314 9.05275 0.600647 8.69675 0.600647C8.34075 0.600647 8.00608 0.739314 7.75475 0.990647L0.666748 8.05665V11H3.60875L10.6967 3.93398ZM8.69675 1.93398L9.75475 2.99065L8.69475 4.04665L7.63741 2.98998L8.69675 1.93398ZM2.00008 9.66665V8.60998L6.69341 3.93131L7.75075 4.98865L3.05808 9.66665H2.00008ZM0.666748 12.3333H11.3334V13.6666H0.666748V12.3333Z"
      fill={color}
    />
  </svg>
);

export default Edit;
